export const BUSINESS_NAME = "American Power Washing and Exterior Services";

export const CONTACT_INFO = {
  PHONE: "608.636.3436",
  EMAIL: "americanpwes@gmail.com",
  ADDRESS: "",
};

export const SOCIAL_MEDIA = {
  FACEBOOK: "",
  INSTAGRAM: "",
  GOOGLE: "",
};
